module.exports = __webpack_public_path__ + "static/media/endgun_true.2770175d.svg";